module.exports = __webpack_public_path__ + "static/media/ayudante virutual.23c6f4e8.png";